import React, { useState, useEffect } from "react";
import "./ToggleButton.css";
import ZustandValidationConjugue from "../../Zustand/ZustandValidationConjugue";

const ToggleButton = ({
  id,
  textOn = "Ligado",
  textOff = "Desligado",
  children,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const {
    setSecondErro,
    setButtonIsAtivo,
    setNomeConjugue,
    setNascimentoConjugue,
    setRendaConjugue,
  } = ZustandValidationConjugue();

  const handleToggle = () => {
    setIsChecked((prev) => !prev);
    setNomeConjugue("");
    setNascimentoConjugue("");
    setRendaConjugue("");
  };

  useEffect(() => {
    setButtonIsAtivo(isChecked);
    setSecondErro(isChecked);
  }, [isChecked, setButtonIsAtivo]);

  return (
    <main>
      <div className="liga-desliga">
        <input
          type="checkbox"
          className="liga-desliga__checkbox"
          id={`liga-desliga-${id}`}
          checked={isChecked}
          onChange={handleToggle}
          style={{ fontFamily: "Inter" }}
        />
        <label
          htmlFor={`liga-desliga-${id}`}
          className="liga-desliga__botao"
        ></label>
        <span className="toggle-text">{isChecked ? textOn : textOff}</span>
      </div>
      {isChecked && <div className="mt-4 text-start">{children}</div>}
    </main>
  );
};

export default ToggleButton;
